import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, Flex } from "sprout-ui-primitives";
import { createElement, useMemo } from "react";
import { stringifyUrl, parse } from "query-string";
import { useLocation } from "react-router-dom";
import { Google, Facebook, Twitter } from "./icons";
const AuthenticateProvider = (props)=>{
    const { provider , variant  } = props;
    const isGoogle = provider === "Google";
    const isFacebook = provider === "Facebook";
    const isTwitter = provider === "Twitter";
    const action = variant === "signin" ? "in" : "up";
    let icon = Google;
    let bg = "grey.200";
    let dataCy = "SocialButton_Google";
    if (isFacebook) {
        icon = Facebook;
        bg = "#3975ea";
        dataCy = "SocialButton_Facebook";
    } else if (isTwitter) {
        icon = Twitter;
        bg = "#4d9fec";
        dataCy = "SocialButton_Twitter";
    }
    const { search , pathname  } = useLocation();
    const { next  } = parse(search);
    const href = useMemo(()=>{
        const isValidPathname = !/^\/+(|auth.*|logout|login|signup)(\?.*)?$/.test(pathname);
        return stringifyUrl({
            url: `/auth/${provider.toLowerCase()}`,
            query: {
                next: next || (isValidPathname ? pathname : undefined)
            }
        });
    }, [
        next,
        pathname,
        provider
    ]);
    return /*#__PURE__*/ _jsxs(Flex, {
        as: "a",
        href: href,
        color: "white.100",
        height: "48px",
        alignItems: "center",
        px: 3,
        borderRadius: "30px",
        bg: bg,
        "data-cy": dataCy,
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                flex: "none",
                children: /*#__PURE__*/ createElement(icon)
            }),
            /*#__PURE__*/ _jsxs(Text, {
                ml: 1,
                as: "span",
                color: isGoogle ? "black.87" : "white.100",
                fontWeight: "bold",
                children: [
                    "Sign ",
                    action,
                    " with ",
                    provider
                ]
            })
        ]
    });
};
export default AuthenticateProvider;
